import { memo } from 'react'

import { Button, Group, Loader, Text } from '@mantine/core'

import classes from './WaitingMessageButton.module.css'

export type ButtonProps = ReactProps<typeof Button<'button'>> & {
  waiting_message: string
}

export const WaitingMessageButton = memo<ButtonProps>(
  function WaitingMessageButton({ waiting_message, ...props }) {
    return (
      <Button
        loaderProps={{
          children: <ExecuteLoader waiting_message={waiting_message} />,
        }}
        classNames={classes}
        miw="min(20em, 100%)"
        px={{ base: 'sm', sm: 'var(--button-padding-x)' }}
        {...props}
      />
    )
  },
)

const ExecuteLoader = memo<{ waiting_message: string }>(function ExecuteLoader({
  waiting_message,
}) {
  return (
    <Group wrap="nowrap" w="100%" h="100%" justify="center" align="center">
      <Loader color="primary.0" size="sm" />
      <Text span inherit>
        {waiting_message}
      </Text>
    </Group>
  )
})
